<template>
  <main class="page-operative page-operative-fiscal-data d-flex flex-column h-100">
    <div class="flex-grow-1 container-fluid d-flex flex-column h-100">
      <div class="d-flex align-items-center justify-content-between mb-5">
        <PageTitle>Dinamica IVA</PageTitle>
      </div>
      <div class="flex-grow-1 d-flex flex-column h-100 overflow-auto">
        <LoadingDataLoader v-if="isLoadingData"></LoadingDataLoader>
        <ErrorOnLoadingDataFeedback v-else-if="errorLoadingData"></ErrorOnLoadingDataFeedback>
        <template v-else>
          <div class="overflow-auto report-texts-size">
            <OperativeTable dense sticky>
              <tbody>
              <OperativeTableBodyHeader :years="tableHeadings" show-years>Aggregato</OperativeTableBodyHeader>
              <OperativeTableBodyRow :values="tableRows.debitoIva">
                Debito IVA
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="tableRows.creditoIva">
                Credito IVA
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="tableRows.ivaDebito">
                IVA a Debito
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="tableRows.ivaCredito">
                IVA a Credito
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="tableRows.versamentiIva">
                Versamenti IVA
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              </tbody>
            </OperativeTable>
          </div>
        </template>
      </div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '../../../../mixins/operativePage';
import loadingDataMixin from '../../../../mixins/loadingData';
import computedFinancialDataMixin from '../../../../mixins/computedFinancialData';
import formatMoneyFilter from '../../../../filters/formatMoney';

export default {
  name: 'page-operative-company-fiscal-data-dinamica-iva',
  mixins: [operativePageMixin, loadingDataMixin, computedFinancialDataMixin],
  components: {
    PageTitle: () => import('../../../components/Layout/LayoutOperative/PageTitle'),
    ErrorOnLoadingDataFeedback: () => import('../../../components/Operative/ErrorOnLoadingDataFeedback'),
    LoadingDataLoader: () => import('../../../components/Operative/LoadingDataLoader'),
    OperativeTable: () => import('../../../components/Operative/OperativeTable'),
    OperativeTableBodyHeader: () => import('../../../components/Operative/OperativeTableBodyHeader'),
    OperativeTableBodyRow: () => import('../../../components/Operative/OperativeTableBodyRow'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  data () {
    return {
      months: [],
    };
  },
  methods: {
    retrieveData () {
      if (!this.company) {
        return;
      }

      this.resetErrorOnLoadingData();
      this.setDataLoading();
      this.$api.getComputedDinamicaIva(this.company?.id)
        .then(res => {
          this.months = res?.data?.months || [];
        })
        .catch(this.setErrorOnLoadingData)
        .finally(this.setDataLoaded)
      ;
    },
  },
  computed: {
    tableHeadings () {
      return this.convertToMonthsHeading(this.months);
    },
    tableRows () {
      return this.convertToRowGroupAutomatically(this.months);
    },
  },
  watch: {
    company () {
      this.retrieveData();
    },
  },
};

</script>
